























































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import RouletteGame from '../../../../GamesCode/Roulette'
import Notice from '@/components/Notice'
import { mapActions, mapState } from 'vuex'


@Component({
  components: {
    Notice
  },
  computed: {
    ...mapState({
      userBalance: ({ gamblingContext }: any) => gamblingContext.userBalance.balance,
      currencyCode: ({ gamblingContext }: any) => gamblingContext.currencyCode
    })
  }
})
export default class Roulette extends Vue {
  @Action('depositAmount') depositAmount: any
  @Action('subtractAmount') subtractAmount: any

  userBalance!: number
  errorText: string = ''
  amountModel: string = '400'
  currencyCode!: string
  amounts: string[] = [
    '100',
    '200',
    '400',
    '800',
    '2500'
  ]

  mounted () {
    this.setUpRouletteGame()
  }

  clearError () {
    this.errorText = ''
  }
  handleLossOrWin (type: string, amount: number | string) {
    if (type === 'Win') {
      this.depositAmount(Number(amount))
    } else if (type === 'Lose') {
      this.subtractAmount(Number(amount))
    }
  }
  updateAmount (amount: string) {
    this.amountModel = amount
  }
  setUpRouletteGame () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vueSelf = this
    const setError = (balance: number | string) => { this.errorText = `Please deposit, your balance is ${this.currencyCode}${balance}` }
    /**
     * @param { object } // vueSelf, this context
     * @param { function } // setError - callback function to set error of balance is not enough
     * @returns { function } // Spins the wheel, mutates the UI and returns the result
     */
    RouletteGame(vueSelf, setError)
  }
}
